import * as fromFreelancer from '../actions/freelancer.action';
import {User} from '../../../users/user';


export interface FreelancerState {
  users: User[];
  user: User;
  loading: boolean;
  loaded: boolean;
  error: string;
  updated: boolean;
  added: boolean;
}

export const initialState = {
  users: null,
  loading: false,
  loaded: true,
  error: null,
  user: null,
  updated: false,
  added: false,
};

export function reducer(state = initialState, action: fromFreelancer.FreelancerAction): FreelancerState {
  switch (action.type) {
    case fromFreelancer.GET_ALL_FREELANCERS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }
    case fromFreelancer.GET_ALL_FREELANCERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: action.payload,
        error: null
      };
    }
    case fromFreelancer.GET_ALL_FREELANCERS_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        user: null,
        error: action.payload
      };
    }
    case fromFreelancer.GET_FREELANCER: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null,
        updated: false,
      };
    }
    case fromFreelancer.GET_FREELANCER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        user: action.payload,
        error: null
      };
    }
    case fromFreelancer.GET_FREELANCER_ERROR: {
      return {
        ...state,
        loading: false,
        loaded: true,
        users: null,
        user: null,
        error: action.payload
      };
    }
    case fromFreelancer.ADD_FREELANCER: {
      return {
        ...state,
        user: action.payload,
        loading: true,
        loaded: false,
        added: false,
        error: null
      };
    }
    case fromFreelancer.ADD_FREELANCER_SUCCESS: {
      return {
        ...state,
        user: action.payload.user,
        loading: false,
        loaded: true,
        added: true,
        error: null
      };
    }
    case fromFreelancer.ADD_FREELANCER_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        added: false,
        loaded: true,
      };
    }
    case fromFreelancer.UPDATE_FREELANCER_SUCCESS: {
      if (state.users) {
        state.users.filter((user, index) => {
          if (user.id === action.payload.id) {
            state.users[index] = action.payload;
          }
        });
      }
      return {
        ...state,
        user: action.payload,
        loading: false,
        loaded: true,
        error: null,
        updated: true,
      };
    }
    case fromFreelancer.UPDATE_FREELANCER: {
      return {
        ...state,
        user: action.payload,
        loading: true,
        loaded: false,
        error: null,
        updated: false,
      };
    }
    case fromFreelancer.UPDATE_FREELANCER_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
        updated: false,
      };
    }

    case fromFreelancer.DELETE_FREELANCER: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      };
    }

    case fromFreelancer.DELETE_FREELANCER_SUCCESS: {
      if (state.users) {
        state.users = state.users.filter(user => user.id !== action.payload.id);
      }
      return {
        ...state,
        user: null,
        loading: false,
        loaded: true,
        error: null
      };
    }
    case fromFreelancer.DELETE_FREELANCER_ERROR: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
      };
    }
  }
  return state;
}




// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/freelancers/store/reducers/freelancer.reducer.ts